<template>
  <v-row justify="center">
    <v-dialog
      v-model="showDialog"
      persistent
      max-width="392"
      transition="dialog-transition"
      id="generalDialog"
    >
      <v-card class="justify-center" :style="styleObject" :loading="loading">
        <template slot="progress">
          <div class="ma-1">
            <v-progress-linear
              color="primary"
              indeterminate
              class="dialog-progress-linear"
            ></v-progress-linear>
          </div>
        </template>
        <v-card-title
          class="py-0 px-2"
          :class="[
            type == 'success'
              ? 'success--text'
              : type == 'error'
              ? 'error--text'
              : 'orange--text',
            dialogLoader
          ]"
        >
          <div class="d-flex align-center">
            <SvgIcon width="48" height="48" :iconType="iconType" />
            <h4 class="ml-2">
              {{ dialogTitle }}
            </h4>
          </div>
          <v-spacer></v-spacer>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="secondary--text text-center pt-5 pb-3"
          >{{ text }}
          <slot name="extra-data"></slot>
        </v-card-text>
        <v-card-actions class="justify-center">
          <div v-if="!oneButton">
            <v-btn
              :id="idCancelButton"
              color="secondary white--text"
              outlined
              rounded
              depressed
              @click="cancel"
              min-width="125"
              class="font-weight-bold"
              :disabled="loading"
            >
              {{ closeButtonText }}</v-btn
            >
            <v-btn
              :id="idSubmitButton"
              color="tertiary white--text"
              rounded
              depressed
              min-width="125"
              class="font-weight-bold mx-1"
              @click="submit"
              :disabled="loading"
            >
              {{ submitButtonText }}</v-btn
            >
          </div>
          <div v-else>
            <v-btn
              :id="idAcceptButton"
              color="secondary white--text"
              outlined
              rounded
              depressed
              @click="oneButtonAction"
              min-width="125"
              class="font-weight-bold mx-1"
            >
              {{ oneButtonText }}</v-btn
            >
          </div>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import { SvgIcon } from '@leapsight/styleguide'
import { i18n } from '@leapsight/portal'
export default {
  props: {
    showDialog: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: ''
    },
    title: {
      type: String
    },
    text: {
      type: String
    },
    closeButtonText: {
      type: String,
      default: i18n.t('general.dialogComponent.closeButtonText')
    },
    submitButtonText: {
      type: String,
      default: i18n.t('general.dialogComponent.acceptButtonText')
    },
    loading: {
      type: Boolean,
      default: false
    },
    oneButton: {
      type: Boolean,
      default: false
    },
    oneButtonText: {
      type: String
    },
    idSubmitButton: {
      type: String
    },
    idCancelButton: {
      type: String
    },
    idAcceptButton: {
      type: String
    }
  },
  components: {
    SvgIcon
  },
  methods: {
    cancel() {
      this.$emit('cancelButtonPressed', true)
    },
    submit() {
      this.$emit('submitButtonPressed', true)
    },
    oneButtonAction() {
      this.$emit('oneButtonAction', true)
    }
  },
  computed: {
    dialog() {
      return this.showDialog
    },
    iconType() {
      let value = ''
      switch (this.type) {
        case 'success':
          value = 'icon_checkmark'
          break
        case 'warning':
          value = 'icon_attention'
          break
        default:
          value = 'icon_attention'
          break
      }
      return value
    },
    styleObject() {
      let obj
      switch (this.type) {
        case 'warning':
          obj = { border: '0px solid #ff6b0e' }
          break
        case 'success':
          obj = { border: '2px solid green' }
          break
        case 'error':
          obj = { border: '2px solid red' }
          break
        default:
          break
      }
      return obj
    },
    dialogTitle() {
      let strToReturn = this.title
      if (typeof this.title == 'undefined')
        switch (this.type) {
          case 'warning':
            strToReturn = 'Advertencia'
            break
          case 'success':
            strToReturn = 'Operación Exitosa'
            break
          case 'error':
            strToReturn = 'Operación fallida'
            break
          default:
            break
        }
      return strToReturn
    },
    dialogLoader() {
      return this.loading ? 'dialog-loader' : ''
    }
  },
  mounted() {
    this.dialog = this.showDialog
  }
}
</script>
<style lang="scss" scoped>
.v-card__text {
  font-size: 1.125rem;
}
.v-card__actions {
  .v-btn--outlined {
    border-width: 1.5px;
  }
  .v-btn {
    letter-spacing: normal !important;
  }
  .v-btn.v-size--default {
    font-size: 0.75rem;
  }
}
.orange--text {
  color: var(--orange) !important;
}

.dialog-loader {
  position: relative;
  padding-top: 32px;
}
.dialog-progress-linear {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
}
</style>
